import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft, faPause, faPlay, faCheck } from '@fortawesome/free-solid-svg-icons';
import "./css/product.css";
import { sliderItems } from "./data/product";
const Products = () => {

    const [isPaused, setIsPaused] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const runAutoInterval = useRef(null);

    const totalSlides = sliderItems.length;

    useEffect(() => {
        const timeAutoNext = 7000;

        function startAutoPlay() {
            clearInterval(runAutoInterval.current);
            runAutoInterval.current = setInterval(() => {
                handleSlideChange("next");
            }, timeAutoNext);
        }

        function stopAutoPlay() {
            clearInterval(runAutoInterval.current);
        }

        if (!isPaused) startAutoPlay();
        else stopAutoPlay();

        return () => {
            stopAutoPlay();
        };
    }, [isPaused, currentIndex]);

    const [direction, setDirection] = useState("next");

    const handleSlideChange = (dir) => {
        setDirection(dir);
        setCurrentIndex((prev) => {
            if (dir === "next") return (prev + 1) % totalSlides;
            else return (prev - 1 + totalSlides) % totalSlides;
        });
    };
    return (<>
        <div className="product-carousel">
            <div className="product-triangle triangle-gray"></div>
            <div className="product-triangle triangle-yellow"></div>
            <div className="product-triangle triangle-yellow-2"></div>

            <div className="pro-carousel" id="product-slider">

                <>

                    {sliderItems.map((item, index) => (
                        <div
                            className={`row pro-slider-item ${index === currentIndex ? "active" : ""}`}
                            key={index}
                            style={{ display: index === currentIndex ? "block" : "none" }}
                        >
                            <div className="pro-wrapper">
                                <div className="pro-render-container">
                                    <div className="row pro-render-area">


                                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 p-content-area">
                                            <div className="pro-item-align">
                                                <div className="pro-width-flex">
                                                    <div className="product-list ">


                                                        <div className="product-content">
                                                            <div className="product-sub-content ">
                                                                <a href={item.url} target="_blank" rel="noopener noreferrer" className="text-header">
                                                                    {item.heading}
                                                                </a>
                                                            </div>
                                                            <div className="product-text-content">
                                                                <div className="product-sections-wrapper">
                                                                    <div className="product-section1">
                                                                        {item.section.map((text, idx) => (
                                                                            <div className="product-name content text-body" key={idx}>
                                                                                <FontAwesomeIcon icon={faCheck} className="tool-icon" />
                                                                                {text}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 banner-img-area pro-img-area">
                                            <div className="content-img-align ">
                                                <div
                                                    className={`product-thumbnail-item  ${index === currentIndex ? "active" : "inactive"} ${direction}`}>
                                                    <img className="product-thumbnail-img img-border" src={item.thumbnail} alt="product-thumbnail" />
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    ))}
                </>

                <div className="pro-arrows">
                    <button id="prev" className="arrow-btn" onClick={() => handleSlideChange("prev")}>
                        <FontAwesomeIcon icon={faChevronLeft} className="arrow-icon" />
                    </button>

                    <button id="product-pause" className="product-arrow-btn " onClick={() => setIsPaused((prev) => !prev)}>
                        <FontAwesomeIcon icon={isPaused ? faPlay : faPause} className="arrow-icon" />
                    </button>

                    <button id="next" className="arrow-btn" onClick={() => handleSlideChange("next")}>
                        <FontAwesomeIcon icon={faChevronRight} className="arrow-icon" />
                    </button>
                </div>

            </div>

        </div>
    </>);
}

export default Products;